import React, { memo, forwardRef } from "react";
const SvgKJ = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M15.6 19.928c.14.15.23.288.272.416.043.128.064.235.064.32 0 .267-.09.496-.272.688a.88.88 0 01-.672.272.93.93 0 01-.448-.112 1.94 1.94 0 01-.464-.384l-3.296-3.584h-.048v3.008c0 .224-.037.41-.112.56a.775.775 0 01-.256.32.725.725 0 01-.32.144.975.975 0 01-.272.048c-.074 0-.17-.016-.288-.048a.85.85 0 01-.32-.144.993.993 0 01-.256-.32 1.426 1.426 0 01-.096-.56v-10.24c0-.224.032-.405.096-.544a.961.961 0 01.256-.336.851.851 0 01.32-.144c.118-.032.214-.048.288-.048.075 0 .166.016.272.048.118.022.224.07.32.144a.763.763 0 01.256.336c.075.139.112.32.112.544v6.72h.048l3.12-3.056c.256-.256.523-.384.8-.384.267 0 .48.086.64.256a.85.85 0 01.256.624c0 .118-.026.24-.08.368-.053.128-.16.267-.32.416l-2.256 2 2.656 2.672zM23.136 17.816c0 .416-.048.854-.144 1.312-.085.459-.25.886-.496 1.28a2.87 2.87 0 01-1.04.976c-.448.256-1.024.384-1.728.384-.608 0-1.141-.106-1.6-.32a2.996 2.996 0 01-1.104-.88 2.649 2.649 0 01-.272-.448 1.166 1.166 0 01-.096-.464c0-.256.085-.474.256-.656a.933.933 0 01.688-.272c.15 0 .293.032.432.096.15.064.299.208.448.432.31.47.715.704 1.216.704.288 0 .523-.053.704-.16a1.03 1.03 0 00.432-.448c.107-.202.181-.437.224-.704.043-.277.064-.576.064-.896v-6.608c0-.234.037-.426.112-.576.075-.15.16-.266.256-.352a.752.752 0 01.336-.16c.117-.032.219-.048.304-.048.085 0 .187.016.304.048a.652.652 0 01.32.16c.107.086.197.203.272.352.075.15.112.342.112.576v6.672z"
      />
    </svg>
  );
});
SvgKJ.displayName = "SvgKJ";
const MemoForwardRef = memo(SvgKJ);
export default MemoForwardRef;
